export default "__VITE_ASSET__9ca1bc63__"